import FormBox from '@/components/form/form-box/form-box'

const FormModal = {
  components: {
    'form-box': FormBox,
  },
  data () {
    return {
      isActive: false,
      activeId: '',
      params: null
    }
  },
  methods: {
    handleClose: function () {
      this.isActive = false
      this.params = null
      this.activeId = ''
    }
  },
  created () {
    bus.$on('form_modal_toggle', (activeId, externalParams) => {
      this.isActive = true
      this.activeId = activeId

      if (externalParams) {
        this.params = externalParams
      }
    })
  }
}

export default FormModal
